const initialState = {
  entryFields: [],
  entryName: '',
  entries: [],
  entry: null,
  drawerEntry: null,
  loading: false,
  success: false,
  error: null,
  isSaved: false,
  entryData: '',
  entryContentTypePreviewUrl: ''
};

const entryReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FORM_SUBMISSION_REQUEST':
      return {
        ...state,
        loading: true,
        success: false
      };
    case 'FORM_SUBMISSION_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        isSaved: true,
        entryData: action.payload
      };
    case 'FORM_SUBMISSION_FAILURE':
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case "GET_CONTENT_TYPE_FOR_ENTRY":
      return {
        ...state,
        entryFields: action.payload.fields,
        entryName: action.payload.name,
        entryContentTypePreviewUrl: action.payload.previewUrl
      };
    case "GET_ALL_ENTRIES":
      return {
        ...state,
        entries: action.payload.entries,
      };
    case "GET_SINGLE_ENTRY":
      return {
        ...state,
        entry: action.payload.entry,
        isSaved: false
      };
    case "GET_ENTRY_FOR_DRAWER":
      return {
        ...state,
        drawerEntry: action.payload.entry,
        isSaved: false
      };
    case "UPDATE_FIELD":
      const updatedFields = state.fields.map((field, idx) =>
        idx === action.payload.index
          ? { ...field, ...action.payload.fieldData }
          : field
      );
      return { ...state, fields: updatedFields };

    case "RESET_FORM":
      return initialState;
    case "GET_CONTENT_TYPES":
      return {
        ...state,
        contentTypes: action.payload,
        isSaved: false
      };
    case "DELETE_ENTRY":
      return {
        ...state,
        entries: state.entries.filter(entry => entry._id !== action.payload),
      }
    default:
      return state;
  }
};

export default entryReducer;
